import React from "react";
import "./About.css";
import Footer from "./Footer";
import img1 from "./images/img1.png";

export default function About() {
  return (
    <div className="about-page" dir="rtl">

      {/* =====================================================
          HERO
      ===================================================== */}

      <div className="about-hero">

        <div className="about-overlay">

          <span className="about-badge">
            ש.מ הובלות ומנופים
          </span>

          <h1>
            אודות
          </h1>

          <p>
            מקצועיות, ניסיון ושירות אישי בכל הובלה והרמה
          </p>

        </div>

      </div>


      {/* =====================================================
          ABOUT CONTENT
      ===================================================== */}

      <section className="about-content-section">

        <div className="about-content">

          {/* תמונה */}

          <div className="about-images">

            <img
              src={img1}
              alt="ש.מ הובלות ומנופים"
            />

          </div>


          {/* טקסט */}

          <div className="text1">

            <h3>
              פתרונות מקצועיים להובלה, הרמה ושינוע עבור לקוחות פרטיים,
              עסקים, חברות, קבלנים, יזמים, מפעלים, מוסדות וארגונים
              בכל רחבי הארץ !
            </h3>


            <p>
              ש.מ הובלות ומנופים מספקת מגוון רחב של שירותי הובלה,
              מנופים, הרמות ושינוע עבור לקוחות פרטיים ועסקיים,
              קבלנים וחברות ברחבי הארץ.
            </p>


            <p>
              אנו מתמחים בהובלות מיוחדות ובהובלת מטענים וציוד
              במגוון גדלים ומשקלים, לרבות הובלת ציוד כבד,
              הובלת חומרי בניין, הובלת מכולות (קונטיינר),
              הובלת עצים, הובלת כספות כבדות, הובלת מכונות כבדות,
              פירוק והעברת מפעלים  .
            </p>


            <p>
              בנוסף, אנו מספקים שירותי מנוף והשכרת מנופים
              למגוון מטרות, לרבות מנוף סל להשכרה, השכרת מנוף
              זרוע, מנוף סל להרמת אדם להשכרה, השכרת סל הרמה,
              משאית מנוף הובלה ושירותים והובלות באמצעות מנוף זרוע.
            </p>


       


            <p>
              בין השירותים שלנו ניתן למצוא גם מנוף הרמה בפתח תקווה ,
              המהווה פתרון לעבודות בגובה ובשטחים צפופים, וכן
              שירותי הובלה ועבודות מנוף במרכז, כולל בפתח תקווה
              ובאזורים נוספים במרכז הארץ וגם בכל רחבי הארץ.
            </p>


            <p>
              השירותים שלנו מתאימים למגוון רחב של לקוחות
              ופרויקטים – החל מהובלות פרטיות ועבודות נקודתיות
              ועד פרויקטים מסחריים, תעשייתיים ועבודות בנייה
              מורכבות.
            </p>


            <p>
              אנו עובדים עם קבלנים, חברות בנייה, מפעלים,
              מחסנים, בעלי עסקים, מתקינים, אנשי מקצוע
              ולקוחות פרטיים הזקוקים לשירותי הובלה,
              הרמה ושינוע.
            </p>


            <p>
              הצוות שלנו פועל במקצועיות ובאחריות, תוך דגש
              על תכנון נכון, התאמת אמצעי ההובלה וההרמה
              למשימה, שמירה על הציוד ומתן שירות אישי,
              אמין וזמין לאורך כל תהליך העבודה.
            </p>


            <p>
              אנו מאמינים שכל עבודה דורשת פתרון המותאם
              באופן מדויק לצורכי הלקוח ולתנאים בשטח.
              לכן אנו מתחילים בהבנת דרישות העבודה, בוחנים
              את סוג המטען, משקלו, מידותיו, תנאי הגישה
              ונקודות האיסוף והפריקה, ובהתאם לכך מתכננים
              את אופן ביצוע העבודה.
            </p>


            <p>
              בפרויקטים שבהם נדרש שילוב בין הובלה, הרמה
              ושינוע, אנו יכולים לספק פתרון משולב המאפשר
              לרכז את העבודה תחת גורם מקצועי אחד ולייעל
              את תהליך ההובלה, ההרמה והפריקה.
            </p>


            <p>
              ש.מ הובלות ומנופים מעניקה שירות בפריסה רחבה
              ברחבי הארץ ומתאימה את הפתרון למיקום העבודה,
              לסוג המטען, למורכבות המשימה ולדרישות הפרויקט.
            </p>


            <p>
              המטרה שלנו היא להעניק לכל לקוח שירות מקצועי,
              מסודר ואמין, החל משלב התכנון והתיאום ועד
              להשלמת ההובלה, ההרמה או השינוע.
            </p>


            {/* =================================================
                SERVICES
            ================================================= */}

            <div className="about-services">

       

              <div className="about-service-item">
                <span>✓</span>
                מנוף סל להשכרה
              </div>

              <div className="about-service-item">
                <span>✓</span>
                השכרת מנוף זרוע
              </div>

              <div className="about-service-item">
                <span>✓</span>
                מנוף סל להרמת אדם להשכרה
              </div>

              <div className="about-service-item">
                <span>✓</span>
                השכרת סל הרמה
              </div>

              <div className="about-service-item">
                <span>✓</span>
                הובלת ציוד כבד
              </div>

              <div className="about-service-item">
                <span>✓</span>
                הובלת חומרי בניין
              </div>

              <div className="about-service-item">
                <span>✓</span>
                הובלת מכולות (קונטיינר)
              </div>

              <div className="about-service-item">
                <span>✓</span>
                הובלת עצים
              </div>

              <div className="about-service-item">
                <span>✓</span>
                הובלת כספות כבדות
              </div>

              <div className="about-service-item">
                <span>✓</span>
                מנוף הרמה בפתח תקווה – הפתרון ההנדסי לעבודות בגובה ובשטחים 
              </div>

              <div className="about-service-item">
                <span>✓</span>
                משאית מנוף הובלה
              </div>

              <div className="about-service-item">
                <span>✓</span>
                שירותים והובלות מנוף זרוע
              </div>

              <div className="about-service-item">
                <span>✓</span>
                הובלת מכונות כבדות – המדריך המלא לשינוע ציוד תעשייתי
              </div>

              <div className="about-service-item">
                <span>✓</span>
                פירוק והעברת מפעלים
              </div>

              <div className="about-service-item">
                <span>✓</span>
               אספקת שירותי הובלה ועבודות מנוף במרכז 
              </div>

            </div>


            {/* =================================================
                FINAL TEXT
            ================================================= */}

            <p className="about-final-text">
              נשמח לעמוד לרשותכם ולהעניק לכם שירות מקצועי,
              אדיב ואמין עם פתרון שמתאים בדיוק לצורך שלכם.
            </p>

          </div>

        </div>

      </section>


      {/* =====================================================
          CONTACT
      ===================================================== */}

    </div>
  );
}
